export const DataMenuItems = [
  { title: "Início", href: "/" },
  { title: "Faturas", href: "/faturas" },
  { title: "Promoções", href: "/promocoes" },
];
